import React from "react";

import whiteLogo from '../assets/images/logos/white.svg'
import greenLogo from '../assets/images/logos/green.svg'
import growthConnectLogoGreen from '../assets/images/logos/2.png'

import lightGreenArrowOutline from '../assets/images/light-outline-arrow.svg'

import { useLocation } from 'react-router-dom';
import PrivateHeader from "./private-header";



const Header = ({activeTab, setActiveTab, isDashboardPage, isDetailPage, isSlotPage, slotInformation, companyName}) => {

    const location = useLocation();
    const isPublicRoute = location.pathname === '/'

    

    return(
        <>
        {
        
        isPublicRoute ?
            <div className="header">
            <img className="logo" src={whiteLogo} alt="" />

        </div>
        :
        <PrivateHeader companyName={companyName} slotInformation={slotInformation} isDashboardPage={isDashboardPage} isSlotPage={isSlotPage} isDetailPage={isDetailPage} activeTab={activeTab} setActiveTab={setActiveTab}/>
        
        }        
    </>
    )
}


export default Header